import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Scrollbar from 'react-scrollbars-custom';
import Label from 'components/_utility/Label';
import { getAccessoryPendingRemoval } from 'src/redux/bike/selectors';
import AccessoryChoiceGroup from 'components/AccessoryChoiceGroup/AccessoryChoiceGroup';
import { Wrap, Heading, Title, Description, Actions, ConfirmButton, CancelButton } from '../ConflictingAccessories/ConflictingAccessories.styled';
import { closeAccessoryResolution, removeRequiredAccessories } from 'src/redux/bike/actions';

const RemoveRequiredAccessories = () => {
  const dispatch = useDispatch();
  const accessoryPendingRemoval = useSelector(getAccessoryPendingRemoval);

  return (
    <Wrap>
      <Title>
        <Label name="removeRequiredAccessoryTitle" />
      </Title>
      <Description>
        <Label name="removeRequiredAccessoryDescription" />
      </Description>
      <Scrollbar noDefaultStyles>
        <Heading>
          <Label name="accessoryLabel" />
        </Heading>
        <AccessoryChoiceGroup accessories={[accessoryPendingRemoval]} noChoice />

        <Heading>
          <Label name="accessoriesToBeRemovedLabel" />
        </Heading>
        <AccessoryChoiceGroup accessories={accessoryPendingRemoval.linkedAccessories} noChoice />

        <Actions>
          <ConfirmButton primary onClick={() => dispatch(removeRequiredAccessories())}><Label name="confirmLabel"></Label></ConfirmButton>
          <CancelButton onClick={() => dispatch(closeAccessoryResolution())}><Label name="cancelLabel"></Label></CancelButton>
        </Actions>
      </Scrollbar>
    </Wrap>
  );
};

export default RemoveRequiredAccessories;
